import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Manage_User.css';
//mport { BASE_URL } from "./Constants.js";
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import * as XLSX from 'xlsx';
import Pagination from './Pagination.js';
import "react-datepicker/dist/react-datepicker.css";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Loader = () => (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
        </div>
        <p>Loading...</p>
    </div>
);

// function to correct date format 2025-02-25 12:32:08.000000 to 10-02-2025
function correctDateFormat(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('-');
}




function Manage_Vehiclenumber() {

    useAuth();
    const [fueltypeData, setFueltypeData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState('id');
    const [sortOrder, setSortOrder] = useState('asc');
    const navigate = useNavigate();
    const token = localStorage.getItem("authToken") || null;
    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}getVehicleNumbers`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                if (result.status) {
                    setItems(result.data);
                    setFueltypeData(result.data);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };

        fetchItems();
    }, [navigate]);
    useEffect(() => {
        console.log('Fetched items:', items); // Add this line to verify the structure

        const filtered = items.filter((item) => {
            const vehicle_number = item.vehicle_number ? item.vehicle_number.toLowerCase() : '';
            const vehicle_type = item.vehicle_type ? item.vehicle_type.toLowerCase() : '';
            const vehicle_modal = item.vehicle_modal ? item.vehicle_modal.toLowerCase() : '';
            const fuel_type = item.fuel_type ? item.fuel_type.toLowerCase() : '';
            const searchLower = searchQuery.toLowerCase();

            return (
            vehicle_number.includes(searchLower) ||
            vehicle_type.includes(searchLower) ||
            vehicle_modal.includes(searchLower) ||
            fuel_type.includes(searchLower)
            );
        });

        const sorted = filtered.sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortOrder === 'asc' ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortOrder === 'asc' ? 1 : -1;
            return 0;
        });

        setFilteredItems(sorted);
        setCurrentPage(1); // Reset to first page when items or search query changes
    }, [searchQuery, items, sortColumn, sortOrder]);

    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const startItem = indexOfFirstItem + 1;
    const endItem = Math.min(indexOfLastItem, filteredItems.length);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };
    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortOrder('asc');
        }
    };
    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className='m-0' style={{ fontSize: '20px' }}>Manage Vehicle Number</h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <section className="col-lg-12 connectedSortable">
                                    <div className="card">
                                        <div className="card-header">
                                            <span style={{ float: "right" }}>
                                                <Link to='/add_vehiclenumber'>
                                                    <button
                                                        type='button'
                                                        className='btn btn-success'>
                                                        <i className="fas fa-plus"></i> Add New
                                                    </button>
                                                </Link>
                                            </span>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                {loading ? (
                                                    <Loader />
                                                ) : (
                                                    <>
                                                        <div className="d-flex justify-content-between mb-3">
                                                            <div className='form-group'>
                                                                <select
                                                                    className='form-control custom-select-sm'
                                                                    value={itemsPerPage}
                                                                    onChange={handleItemsPerPageChange}
                                                                >
                                                                    <option value={10}>10</option>
                                                                    <option value={50}>50</option>
                                                                    <option value={100}>100</option>
                                                                </select>
                                                            </div>

                                                            <div className='dataTables_filter'>
                                                                <label>
                                                                    <input
                                                                        type='search'
                                                                        value={searchQuery}
                                                                        onChange={handleSearchChange}
                                                                        className='form-control form-control-sm'
                                                                        placeholder='Search'
                                                                        aria-controls='example1'
                                                                    />
                                                                </label>
                                                            </div>
                                                        </div>
                                                         
                                                        <table className="table table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th onClick={() => handleSort('id')}>ID {sortColumn === 'id' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                                                                    <th onClick={() => handleSort('vehicle_number')}>Vehicle Number {sortColumn === 'vehicle_number' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                                                                    <th onClick={() => handleSort('vehicle_type')}>Type {sortColumn === 'vehicle_type' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                                                                    <th onClick={() => handleSort('vehicle_modal')}>Model {sortColumn === 'vehicle_modal' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                                                                    <th onClick={() => handleSort('fuel_type')}>Fuel Type {sortColumn === 'fuel_type' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                                                                    <th onClick={() => handleSort('createdDTM')}>Created Date {sortColumn === 'createdDTM' && (sortOrder === 'asc' ? '↑' : '↓')}</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentItems.map((item) => (
                                                                    <tr key={item.id}>
                                                                        <td>{item.id}</td>
                                                                        <td>{item.vehicle_number}</td>
                                                                        <td>{item.vehicle_type}</td>
                                                                        <td>{item.vehicle_modal}</td>
                                                                        <td>{item.fuel_type}</td>
                                                                        <td>{correctDateFormat(item.createdDTM)}</td>
                                                                        <td>
                                                                            <Link to={`/edit_vehiclenumber/${item.id}`}>
                                                                                <button
                                                                                    className="btn btn-primary btn-sm"
                                                                                    title="Edit">
                                                                                    <i className="fas fa-edit"></i>
                                                                                </button>
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </>
                                                )}
                                            </div>
                                        </div> 
                                        <div className="card-footer">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    Showing {startItem} to {endItem} of {filteredItems.length} entries
                                                </div>
                                                <Pagination
                                                    currentPage={currentPage}
                                                    totalPages={totalPages}
                                                    handlePageChange={handlePageChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Manage_Vehiclenumber